module.exports = __webpack_public_path__ + "static/media/terminalicon.db3f20a4.svg";